import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fe3fc95"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLOrderStatuses" }
const _hoisted_2 = { class: "FTLOrderStatuses__container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__title" }, "Статусы", -1))
const _hoisted_4 = {
  key: 0,
  class: "container__empty"
}
const _hoisted_5 = {
  key: 1,
  class: "container__statuses"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statuses__line" }, null, -1))
const _hoisted_7 = { class: "status__container" }
const _hoisted_8 = { class: "flex items-center gap-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check-circle text-blue-500" })
], -1))
const _hoisted_10 = { class: "container__name" }
const _hoisted_11 = { class: "container__date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.statuses.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Нет статусов"))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "statuses__status",
                key: `status-${i}`
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, _toDisplayString(status.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.formatDateWithTimeFromBackend(status.created_at)), 1)
                ])
              ]))
            }), 128))
          ]))
    ])
  ]))
}